import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import TrustedBySection from './components/TrustedBySection';
import AnatomySection from './components/AnatomySection';
import OurServicesSection from './components/OurServicesSection';
import CostOfInactionSection from './components/CostOfInactionSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import AmazonRegistrySection from './components/AmazonRegistrySection';
import PricingSection from './components/PricingSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import GuaranteeSection from './components/GuaranteeSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import TrademarkRegistration from './pages/services/TrademarkRegistration';
import CopyrightRegistration from './pages/services/CopyrightRegistration';
import CompanyFormation from './pages/services/CompanyFormation';
import TrademarkSearch from './pages/services/TrademarkSearch';
import AmazonBrandRegistry from './pages/services/AmazonBrandRegistry';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const open = () => setIsContactFormOpen(true);
  const close = () => setIsContactFormOpen(false);

  return (
    <div className="bg-white">
      <Header onOpenContactForm={open} />
      <HeroBanner />
      <TrustedBySection />
      <AnatomySection />
      <OurServicesSection onOpenContactForm={open} />
      <CostOfInactionSection />
      <HowWeWorkSection />
      <AmazonRegistrySection onOpenContactForm={open} />
      <PricingSection onOpenContactForm={open} />
      <WhyChooseUsSection onOpenContactForm={open} />
      <TestimonialsSection />
      <FAQSection />
      <GuaranteeSection onOpenContactForm={open} />
      <Footer onOpenContactForm={open} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={close} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
          <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
          <Route path="/services/company-formation" element={<CompanyFormation />} />
          <Route path="/services/trademark-search" element={<TrademarkSearch />} />
          <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
